import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '@/context/AuthContext';
import { logError } from '@/lib/logger';

const API = process.env.REACT_APP_BACKEND_URL;
const POLL_INTERVAL_MS = 60000;

export const useCircleUnread = () => {
  const { token, user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [hasUnread, setHasUnread] = useState(false);
  const isSubscriber = ['active', 'trialing'].includes(user?.subscription_status || '');

  const fetchUnread = useCallback(async () => {
    if (!token || !isSubscriber) return;
    try {
      const res = await fetch(`${API}/api/circle/unread`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setUnreadCount(data.unread_count);
        setHasUnread(data.has_unread);
      }
    } catch (err) {
      logError('Unread count fetch failed:', err);
    }
  }, [token, isSubscriber]);

  useEffect(() => {
    fetchUnread();
    const interval = setInterval(fetchUnread, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [fetchUnread]);

  const markVisited = useCallback(async () => {
    if (!token) return;
    try {
      await fetch(`${API}/api/circle/mark-visited`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
      setUnreadCount(0);
      setHasUnread(false);
    } catch (err) {
      logError('Mark visited failed:', err);
    }
  }, [token]);

  return { unreadCount, hasUnread, isSubscriber, markVisited };
};
